import "../css/animacion_de_carga.css";

function AnimacionCarga() {
  return (
    <div className="AnimacionCarga">
      <div className="bouncing-dots">
        <div className="dot"></div>
        <div className="dot"></div>
        <div className="dot"></div>
      </div>
    </div>
  );
}

export default AnimacionCarga;